/**
 * Service: saleChannel
 */
angular.module('acme.common.filter.saleChannel', [])
.filter('saleChannel', [function() {

  return function(input, channel) {

    var i, ii,
        j, jj,
        k, kk,
        inverse,
        channels,
        _channel,
        filtered = [];

    if (channel) {
      if (channel.match(/,+/)) {
        channels = channel.split(',');
      }else{
        channels = [channel];
      }
      for (i = 0, ii = input.length; i < ii; i++) {
        inner: for (j = 0, jj = input[i].salesChannels.length; j < jj; j++) {
          if (channels instanceof Array) {
            for (k = 0, kk = channels.length; k < kk; k++) {
              inverse = (/^!/.test(channels[k]));
              _channel = channels[k];

              if (inverse) {
                _channel = _channel.substr(1, channels[k].length);
              }

              if (input[i].salesChannels[j].channel === _channel && input[i].salesChannels[j].enabled !== inverse) {
                filtered.push(input[i]);
                break inner;
              }
            }
          }
        }
      }
    }else{
      filtered = input;
    }

    return filtered;

  };

}]);